import { render, staticRenderFns } from "./people-filter-official.vue?vue&type=template&id=68c78a2e&scoped=true"
import script from "./people-filter-official.vue?vue&type=script&lang=js"
export * from "./people-filter-official.vue?vue&type=script&lang=js"
import style0 from "./people-filter-official.vue?vue&type=style&index=0&id=68c78a2e&prod&lang=scss&scoped=true"
import style1 from "./people-filter-official.vue?vue&type=style&index=1&id=68c78a2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c78a2e",
  null
  
)

export default component.exports